import React, { useEffect, useState } from "react";
import { getShopAnalyticsSummary } from "../utils/api";

export default function SalesAnalytics() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await getShopAnalyticsSummary();
        setData(result);
      } catch (err) {
        setError(err?.message || "Failed to load analytics");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Sales Analytics</h3>
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          <div className="h-4 bg-gray-200 rounded w-2/3" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Sales Analytics</h3>
        <p className="text-sm text-red-600">{error}</p>
      </div>
    );
  }

  const weekRevenue = Number(data?.weekRevenue || 0);
  const monthRevenue = Number(data?.monthRevenue || 0);
  const weekOrders = Number(data?.weekOrders || 0);
  const monthOrders = Number(data?.monthOrders || 0);

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Sales Analytics</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-sm text-gray-600 mb-1">This Week</div>
          <div className="text-2xl font-bold text-gray-900">
            ${weekRevenue.toFixed(2)}
          </div>
          <div className="text-xs text-gray-500 mt-1">{weekOrders} orders</div>
        </div>

        <div>
          <div className="text-sm text-gray-600 mb-1">This Month</div>
          <div className="text-2xl font-bold text-gray-900">
            ${monthRevenue.toFixed(2)}
          </div>
          <div className="text-xs text-gray-500 mt-1">{monthOrders} orders</div>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200">
        <a
          href="/shop/views"
          className="text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          View detailed analytics →
        </a>
      </div>
    </div>
  );
}
